import React, { Component } from 'react'
import css from './styles.scss'

export class Amount extends Component {
  constructor ({ quantity, schema }) {
    super()
    this.state = {
      quantity: quantity || ''
    }
  }

  handleUpdateAmount = evt => {
    const enteredAmount = evt.target.value
    const quantity = enteredAmount >= 0 ? enteredAmount : this.state.quantity
    this.setState({
      quantity
    }, () => this.save())
  }

  save = () => {
    const value = isNaN(parseFloat(this.state.quantity)) ? null : parseFloat(this.state.quantity)
    this.props.save(this.props.dataKey, value, this.props.idx)
  }

  render () {
    const { quantity } = this.state
    const { schema } = this.props
    return (
      <div className={css.Amount}>
        <label className={css.label}>
          <span className={css.schemas}>
            {schema.templates.join(', ')}
          </span>
          {schema.label}
        </label>
        <input type='number' value={quantity} onChange={this.handleUpdateAmount} className={css.input} />
      </div>
    )
  }
}

export default Amount



// WEBPACK FOOTER //
// /app/js/components/EditorGUI/Amount/index.js